import * as React from 'react';
import { IconButton, MenuItem, TextField, Tooltip } from '@bb-ui/react-library';
import { makeStyles, createStyles } from '@bb-ui/react-library/dist/components/styles';
import { Information } from '@bb-ui/icons/dist/small';
import { useTranslation } from 'react-i18next';
import { useJobRegion } from 'contexts/JobRegionContext';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      justifyContent: 'flex-end',
      width: '100%',
    },
    select: {
      minWidth: 180,
    },
  }),
);

export const JobRegionPicker: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { showRegionPicker, jobRegion, setJobRegion, jobRegions } = useJobRegion();

  if (!showRegionPicker) return null;

  return (
    <div className={classes.container}>
      <TextField
        select
        id="job-region-select"
        label={t('jobService.selectRegion')}
        value={jobRegion ?? ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setJobRegion(e.target.value)}
        className={classes.select}
        floatingLabel
        InputLabelProps={{ shrink: true, disableAnimation: true }}
      >
        {jobRegions.map((region) => (
          <MenuItem key={region} value={region}>
            {region}
          </MenuItem>
        ))}
      </TextField>
      <Tooltip title={t('jobService.selectRegionTooltip')} placement="top">
        <IconButton aria-label={t('jobService.selectRegionTooltip')} size="small">
          <Information />
        </IconButton>
      </Tooltip>
    </div>
  );
};
